import Text from '@sats-group/ui-lib/react/text';
import cn from 'classnames';
import React from 'react';
import type { ComponentList as Props } from './component-list.types';

/** https://www.figma.com/design/dQeQgh6sANMhWBUNtgXQNN/satsweb-components?node-id=6245-70880 */
const ComponentList = <T extends { tall?: boolean }>({
  description,
  entryRenderer,
  entries,
  title,
  columnCount = 4,
}: Props<T> & { entryRenderer: React.FC<T> }) => {
  const EntryRenderer = entryRenderer;
  const columns =
    entries.length === 2 || entries.length === 3 ? entries.length : columnCount;

  return (
    <div className="component-list">
      {description || title ? (
        <div className="component-list__texts">
          {title ? (
            <Text
              elementName="h2"
              size={Text.sizes.headline1}
              theme={Text.themes.emphasis}
              tight
            >
              {title}
            </Text>
          ) : null}
          {description ? (
            <Text
              className="component-list__description"
              elementName="p"
              size={Text.sizes.basic}
              tight
            >
              {description}
            </Text>
          ) : null}
        </div>
      ) : null}
      <div
        className={cn(
          'component-list__entries',
          `component-list__entries--${columns}-columns`
        )}
      >
        {entries.map(item => (
          <div className="component-list__entry" key={item.key}>
            <EntryRenderer {...item.props} tall />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComponentList;
